import React, { useEffect, useState } from 'react'
import { Section } from '@/components/shared/section/Section'
import { env } from '@/utils/constants/env'
import { UserService } from '@/api/user'
import { Loading } from '@/components/ui/Loading'
import { useFetch } from '@/hooks/useFetch'

export const KpiBulanan: React.FC = () => {
  const { data: userData, isLoading: isLoadingProfile } = UserService.useGetProfile()
  const {
    data: urlMetabase,
  } = useFetch({
    path: '/api/v1/metabase?dashboard=101&filter[fullname_tim]=' + userData?.fullname,
  })

  const [url, setUrl] = useState<string>(env.iFrameMetabaseKpiBulanan)

  useEffect(() => {
    const role = userData?.role?.toLowerCase()

    if(role?.includes('manager') || role?.includes('staff hr')) {
      const fullnameTim = userData?.fullname?.replace(/\s+/g, '+')
      const newUrl = `${env.iFrameMetabaseKpiBulanan}?fullname_tim=${fullnameTim}`

      setUrl(newUrl)
    } else {
      // @ts-ignore
      setUrl(urlMetabase)
    }
  }, [userData, urlMetabase])

  if (isLoadingProfile) return <Loading />

  return (
    <Section title="Dashboard Pemantauan KPI Bulanan & Mingguan">
      <div className="flex flex-col items-center gap-1 p-10">
        <iframe
          title="Pemantauan KPI Bulanan & Mingguan"
          src={url}
          width="100%"
          height="600"
          style={{ border: 'none' }}
        />
      </div>
    </Section>
  )
}
